import { FC, useEffect, useState } from "react";
import { getUsers, User } from "src/apis/user";
import PageContainer from "src/pages/components/PageContainer";
import UserTable from "./components/UserTable";
import { isUserAdministrator } from "src/utils/auth";
import RegisterFab from "src/pages/components/RegisterFab";
import { Box } from "@mui/material";

const Users: FC = (): JSX.Element => {
  const [users, setUsers] = useState<User[]>([]);
  const [error, setError] = useState<string>('');

  const fetchData = async (): Promise<void> => {
    try {
      const res = await getUsers();

      setUsers(res);
      setError('');
    } catch (err: any) {
      setError(err?.message);
    }
  }

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <PageContainer title="Usuários" error={error} guard={isUserAdministrator}>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "0.5rem",
          justifyContent: "center",
          alignItems: "center",
          width: "100%"
        }}
      >
        <RegisterFab registerUrl={"/usuario/cadastro"} />
      </Box>

      <UserTable users={users} />
    </PageContainer>
  )
}

export default Users;
